import Img from '@admin/components/html/img'
import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import moment from 'moment'
import React from 'react'

class Results extends React.Component {

  static propTypes = {
    records: PropTypes.array,
    selected: PropTypes.array,
    onChoose: PropTypes.func
  }

  render() {
    const { records } = this.props
    return (
      <div className="payoutsfield-payments">
        { records.length === 0 &&
          <div className="payoutsfield-payments-empty">
            <T text="There are no unissued payments" />
          </div>      
        }
        { records.map((record, index) => (
          <div className={ this._getClass(record) } key={`record_${index}`} onClick={ this._handleChoose.bind(this, index) }>
            <div className="payoutsfield-payment-icon">
              <Icon icon={  this._getIcon(index) } />
            </div>
            <div className="payoutsfield-payment-method">
              <div className="finance-payment-type-token">
                <Img src={`/images/payments/${record.service}.png`} />
              </div>
            </div>
            <div className="payoutsfield-payment-label">
              <span>{ moment(record.date).format('MM/DD/YY') }</span><br />
              <strong>{ record.affiliate.team.title }</strong>
            </div>
            <div className="payoutsfield-payment-amount">
              { numeral(record.total).format('0.00') }
            </div>
          </div>
        )) }
      </div>
    )
  }

  _getClass(record) {
    const classes = ['payoutsfield-payment']
    if(this._getChecked(record)) classes.push('selected')
    return classes.join(' ')
  }

  _getChecked(index) {
    const { selected } = this.props
    return _.includes(selected, index)
  }

  _getIcon(index) {
    return this._getChecked(index) ? 'check-circle' : 'circle-o'
  }

  _handleChoose(index) {
    this.props.onChoose(this._getChecked(index) ? this.props.selected.filter(i => {
      return index !== i
    }) : [
      ...this.props.selected,
      index
    ])
  }

}
export default Results
